'use client';

import { FC, useState } from 'react';
import { Dialog, DialogContent } from '@tuic/web-compositions/shared/Dialog';
import PrismAPI from '@modules/prism-client/types/prism-types';
import { AddBookingForm } from './AddBookingForm';
import { useDialogTelemetry } from '@modules/prism-client/lib/telemetry';
import { Button } from '@modules/prism-client/components/elements';

type AddBookingDialogProps = {
  title: string;
  openButton: PrismAPI.ButtonElement;
  form: PrismAPI.Form;
};

export const AddBookingDialog: FC<AddBookingDialogProps> = ({
  title,
  openButton,
  form,
}) => {
  const [open, setOpen] = useState(false);

  useDialogTelemetry(openButton.telemetry, open);

  return (
    <>
      <Button data={openButton} onClick={() => setOpen(true)} />
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent bodyClassName="bg-white" title={title}>
          <AddBookingForm form={form} onSuccess={() => setOpen(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
};
